import { useSelector } from "react-redux";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import max from "lodash/fp/max";
import pick from "lodash/fp/pick";
import toNumber from "lodash/fp/toNumber";
import uniq from "lodash/fp/uniq";
import values from "lodash/fp/values";

import { selectUserChoiceValues } from "store/app";
import { useTranslation } from "hooks";
import ButtonOptions from "../ButtonOptions";
import { getIsDisabled } from "../FieldsSelector/FieldsSelectorWrapper";

const mapWithIndex = map.convert({ cap: false });

const FIT_MAP = {
  3: { FIT_3D: "3", FIT1: "230", FIT2: "230", FIT3: "230" },
  4: { FIT_3D: "4", FIT1: "238", FIT2: "238", FIT3: "238" },
  5: { FIT_3D: "5", FIT1: "246", FIT2: "246", FIT3: "246" },
  6: { FIT_3D: "6", FIT1: "254", FIT2: "254", FIT3: "254" },
  7: { FIT_3D: "7", FIT1: "263", FIT2: "263", FIT3: "263" },
  8: { FIT_3D: "8", FIT1: "272", FIT2: "272", FIT3: "272" },
  9: { FIT_3D: "9", FIT1: "280", FIT2: "280", FIT3: "280" },
  10: { FIT_3D: "10", FIT1: "288", FIT2: "288", FIT3: "288" },
  11: { FIT_3D: "11", FIT1: "296", FIT2: "296", FIT3: "296" },
  12: { FIT_3D: "12", FIT1: "306", FIT2: "306", FIT3: "306" },
  13: { FIT_3D: "13", FIT1: "306", FIT2: "306", FIT3: "306" },
  14: { FIT_3D: "14", FIT1: "322", FIT2: "322", FIT3: "322" },
  15: { FIT_3D: "15", FIT1: "322", FIT2: "322", FIT3: "322" },
  3.25: { FIT_3D: "3.25", FIT1: "230", FIT2: "230", FIT3: "230" },
  3.5: { FIT_3D: "3.5", FIT1: "230", FIT2: "230", FIT3: "238" },
  3.75: { FIT_3D: "3.75", FIT1: "238", FIT2: "238", FIT3: "238" },
  4.25: { FIT_3D: "4.25", FIT1: "238", FIT2: "238", FIT3: "238" },
  4.5: { FIT_3D: "4.5", FIT1: "238", FIT2: "238", FIT3: "246" },
  4.75: { FIT_3D: "4.75", FIT1: "246", FIT2: "246", FIT3: "246" },
  5.25: { FIT_3D: "5.25", FIT1: "246", FIT2: "246", FIT3: "246" },
  5.5: { FIT_3D: "5.5", FIT1: "246", FIT2: "246", FIT3: "254" },
  5.75: { FIT_3D: "5.75", FIT1: "254", FIT2: "254", FIT3: "254" },
  6.25: { FIT_3D: "6.25", FIT1: "254", FIT2: "254", FIT3: "254" },
  6.5: { FIT_3D: "6.5", FIT1: "254", FIT2: "254", FIT3: "263" },
  6.75: { FIT_3D: "6.75", FIT1: "263", FIT2: "263", FIT3: "263" },
  7.25: { FIT_3D: "7.25", FIT1: "263", FIT2: "263", FIT3: "263" },
  7.5: { FIT_3D: "7.5", FIT1: "263", FIT2: "263", FIT3: "272" },
  7.75: { FIT_3D: "7.75", FIT1: "272", FIT2: "272", FIT3: "272" },
  8.25: { FIT_3D: "8.25", FIT1: "272", FIT2: "272", FIT3: "272" },
  8.5: { FIT_3D: "8.5", FIT1: "272", FIT2: "272", FIT3: "280" },
  8.75: { FIT_3D: "8.75", FIT1: "280", FIT2: "280", FIT3: "280" },
  9.25: { FIT_3D: "9.25", FIT1: "280", FIT2: "280", FIT3: "280" },
  9.5: { FIT_3D: "9.5", FIT1: "280", FIT2: "280", FIT3: "288" },
  9.75: { FIT_3D: "9.75", FIT1: "288", FIT2: "288", FIT3: "288" },
  10.25: {
    FIT_3D: "10.25",
    FIT1: "288",
    FIT2: "288",
    FIT3: "288",
  },
  10.5: { FIT_3D: "10.5", FIT1: "288", FIT2: "288", FIT3: "296" },
  10.75: {
    FIT_3D: "10.75",
    FIT1: "296",
    FIT2: "296",
    FIT3: "296",
  },
  11.25: {
    FIT_3D: "11.25",
    FIT1: "296",
    FIT2: "296",
    FIT3: "296",
  },
  11.5: { FIT_3D: "11.5", FIT1: "296", FIT2: "296", FIT3: "306" },
  11.75: {
    FIT_3D: "11.75",
    FIT1: "306",
    FIT2: "306",
    FIT3: "306",
  },
  12.25: {
    FIT_3D: "12.25",
    FIT1: "306",
    FIT2: "306",
    FIT3: "306",
  },
  12.5: { FIT_3D: "12.5", FIT1: "306", FIT2: "306", FIT3: "306" },
  12.75: {
    FIT_3D: "12.75",
    FIT1: "306",
    FIT2: "306",
    FIT3: "306",
  },
  13.25: {
    FIT_3D: "13.25",
    FIT1: "306",
    FIT2: "306",
    FIT3: "306",
  },
  13.5: { FIT_3D: "13.5", FIT1: "306", FIT2: "306", FIT3: "322" },
  13.75: {
    FIT_3D: "13.75",
    FIT1: "322",
    FIT2: "322",
    FIT3: "322",
  },
  14.25: {
    FIT_3D: "14.25",
    FIT1: "322",
    FIT2: "322",
    FIT3: "322",
  },
  14.5: { FIT_3D: "14.5", FIT1: "322", FIT2: "322", FIT3: "322" },
  14.75: {
    FIT_3D: "14.75",
    FIT1: "322",
    FIT2: "322",
    FIT3: "322",
  },
};

export default function SkateHolderLength({
  value: selectedValue,
  hint,
  onChange,
}) {
  const { t } = useTranslation();

  const userChoiceValues = useSelector(selectUserChoiceValues);

  const { sizeLeft, sizeRight, fit } = useSelector((state) => {
    const fromUserChoiceValues = pick(["size_left", "size_right", "Fit"])(
      state.app.userChoiceValues
    );
    const fromRecommendedValues = getOr({}, [
      "app",
      "volumentalData",
      "recommended_skate",
    ])(state);
    return {
      sizeLeft:
        fromUserChoiceValues.size_left || fromRecommendedValues.size_left,
      sizeRight:
        fromUserChoiceValues.size_right || fromRecommendedValues.size_right,
      fit: fromUserChoiceValues.Fit || fromRecommendedValues.fit,
    };
  });

  const getFromFitMap = (size) => get([size, fit])(FIT_MAP);
  const allFitSizes = flow(values, map(get(fit)), uniq)(FIT_MAP);

  const options = flow(
    map(toNumber),
    max,
    getFromFitMap,
    (value) => [value, allFitSizes.filter((v) => v > value)[0]],
    filter(Boolean),
    mapWithIndex((value, index, values) => {
      const isRecommended = values.length > 1 && index === 0;
      const isOneSizeUp = values.length > 1 && index === 1;

      const isDisabledIf =
        isOneSizeUp && parseInt(values[0] || "0", 10) >= "306"
          ? {
              "Blade Type": {
                includes: ["LS CarbonLite"],
              },
            }
          : null;

      return {
        value,
        label: [
          value,
          isRecommended && t(" - Recommended*"),
          isOneSizeUp && t(" - One Size Up"),
        ]
          .filter(Boolean)
          .join(""),
        isOneSizeUp,
        isDisabledIf,
        toolTip: (isRecommended || isOneSizeUp) && {
          component: "TextToolTip",
          props: {
            label: isRecommended
              ? t(
                  "Based on performance testing, recommended for optimal control of blade."
                )
              : isOneSizeUp
              ? t("Lorem Ipsum")
              : "",
          },
        },
      };
    }),
    map(({ isDisabledIf, ...option }) => {
      return {
        ...option,
        isDisabled:
          isDisabledIf && getIsDisabled({ isDisabledIf, userChoiceValues }),
      };
    })
  )([sizeLeft, sizeRight]);

  return (
    <ButtonOptions
      options={options}
      value={selectedValue}
      hint={options.length > 1 && hint}
      onChange={onChange}
    />
  );
}
